import React from 'react';
import { BalanceText, Container, QuestionText, StyledCheckbox, CheckboxContainer } from './TokensFromWallet.styles';
import { useBalanceArch } from '@components/store/getters';
import { roundNumber } from 'utils/roundNumber';

interface TokensFromWalletProps {
  tokenFeeInArch?: number;
  setUseArchFromWallet: (checked?: boolean) => void;
  useArchFromWallet: boolean;
}

const TokensFromWallet = ({ tokenFeeInArch, setUseArchFromWallet, useArchFromWallet }: TokensFromWalletProps) => {
  const balanceArch = roundNumber(Number(useBalanceArch()), 2);

  return (
    <Container>
      <CheckboxContainer>
        <StyledCheckbox onChange={setUseArchFromWallet} checked={useArchFromWallet} />
      </CheckboxContainer>
      <div>
        <QuestionText type="span" key={tokenFeeInArch}>
          Pay <strong>{tokenFeeInArch || 0}</strong> ARCH token fee from your wallet balance
        </QuestionText>
        <BalanceText type="span" key={balanceArch}>
          Balance: <strong>{balanceArch}</strong> ARCH
        </BalanceText>
      </div>
    </Container>
  );
};

export default TokensFromWallet;
